import './NielsenSurvey.css';
import { h } from 'preact';
import Survey from './Survey';
import * as is from 'Services/Misc/is';
import { getUID } from 'Services/Misc/id';
import { now, seconds, expiringAction } from 'Services/Misc/timing';
import { getCampaignIDFromIframe, getNielsenVideoTag } from 'Services/Misc/survey';

export default class NielsenSurvey extends Survey {
  constructor() {
    super();
    this.msgID = `vmc${getUID()}`;
    this.handleMessage = this.handleMessage.bind(this);
    this.listening = false;
    this.invalid = false;
    this.timeoutHandler = {};
    this.actionExpired = this.actionExpired.bind(this);
  }

  componentWillReceiveProps(props) {
    if(this.canShow(props.state)) {
      this.tagURL = this.getTagURL(props);
      if(this.tagURL) {
        this.setup();
      } else {
        console.warn('unable to get survey tag');
        this.surveyInvalid();
      }
    } else {
      this.teardown();
    }
  }

  getTagURL(props) {
    const survey     = props.state.configuration.UI.survey,
          campaignID = getCampaignIDFromIframe(survey);

    if(campaignID) {
      const tagURL = getNielsenVideoTag(props.state.configuration.Ad_Context, campaignID);
      return tagURL ? tagURL.concat(`&uuid=${this.msgID}`) : undefined;
    }
  }

  setup() {
    if(!this.listening) {
      window.addEventListener('message', this.handleMessage);
      this.listening = true;
      this.tagContainer = this.generateTagContainer(this.props);
      this.waitForNextEvent('receive AdReady');
    }
  }

  teardown() {
    if(this.listening) {
      window.removeEventListener('message', this.handleMessage);
      this.listening = false;
      delete this.tagContainer;
    }
  }

  generateTagContainer(props) {
    return (
      <div className="surveyContainer full">
        <iframe
          ref={ el => this.tag = el }
          src={ this.tagURL }
          scrolling="no"
          className="surveyIFrame full"
        ></iframe>
      </div>
    );
  }

  handleMessage(msg = {}) {
    msg = this.getMessage(msg);

    if(msg.UUID && msg.UUID === this.msgID) {
      this.timeoutHandler.resolve && this.timeoutHandler.resolve();

      switch(msg.type) {
        case 'AdReady':
          this.sendMessage('InitAd');
          this.waitForNextEvent('receive AdLoaded');
          break;
        case 'AdLoaded':
          this.sendMessage('StartAd');
          this.waitForNextEvent('receive AdStopped', seconds(20));
          break;
        case 'AdStopped':
          this.teardown();
          this.props.onSurveyComplete();
          break;
      }
    }
  }

  getMessage({ data }) {
    if(is.jsonStr(data)) {
      try {
        return JSON.parse(data);
      } catch(e) {
        console.error('error parsing survey message', e);
      }
    } else if(is.obj(data)) {
      return data;
    }
  }

  sendMessage(msg = '') {
    try {
      msg = JSON.stringify({ type: msg, UUID: this.msgID });
      this.tag.contentWindow.postMessage(msg, '*');
    } catch(e) {
      console.error('error sending survey message', e);
    }
  }

  waitForNextEvent(description, duration) {
    this.timeoutHandler = expiringAction(description, duration);
    this.timeoutHandler.promise.catch(this.actionExpired);
  }

  actionExpired() {
    console.warn('survey timeout');
    this.surveyInvalid();
  }

  surveyInvalid() {
    this.invalid = true;
    this.teardown();
    this.props.onSurveyComplete({ invalid: this.invalid });
  }

  render(props) {
    if(this.canShow(props.state)) {
      return this.tagContainer;
    }

    return null;
  }

  canShow(state) {
    return is.def(state.configuration.UI.survey) && (state.media.complete || !state.media.started) && !this.invalid;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/Surveys/NielsenSurvey.js